module.exports = __webpack_public_path__ + "img/9.85b54f12.png";